module.exports = __webpack_public_path__ + "static/media/appwrite.f2a9d684.svg";